import { render, staticRenderFns } from "./RequestCard.vue?vue&type=template&id=19e4dbb3&scoped=true&"
import script from "./RequestCard.vue?vue&type=script&lang=js&"
export * from "./RequestCard.vue?vue&type=script&lang=js&"
import style0 from "./RequestCard.vue?vue&type=style&index=0&id=19e4dbb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e4dbb3",
  null
  
)

export default component.exports